import AdReport from '@wmfe/ad-report-machpro';
import { reportCodeTryException } from '@/common/exception';
import { reportRaptorMetrics } from '@/src/common/SLRaptor';

export const HIT_AD = 1;

export interface AdInfo {
  hitAd: number; //是否命中广告，1-命中 0-未命中
  adLabel: string;
  adType: number; //广告类型
  adPoiInfo: string; //广告数据，json串
  pos: number; //广告位置
}

const getAdChargeInfo = (adInfo: any) => {
  try {
    const adShopInfoJson: string = adInfo?.adShopInfo;
    const adShopInfo = JSON.parse(adShopInfoJson || '{}');
    return adShopInfo?.chargeInfo || '';
  } catch (error: any) {
    console.log('getAdChargeInfo parse chargeInfo failed');
    reportCodeTryException({
      message: 'getAdChargeInfo',
      extra: error
    });
    return '';
  }
};

export const reportChargeMc = (eventId: string, adInfo: any) => {
  if (adInfo?.hitAd === HIT_AD) {
    const adChargeInfo = getAdChargeInfo(adInfo);
    reportRaptorMetrics({ adChargeInfoReport: adChargeInfo ? 1 : 0 }, {
      result: adChargeInfo ? 'success' : 'fail',
      type: 'mc',
      eventId
    });
    if (!adChargeInfo) {
      console.log('reportChargeMc, adChargeInfo is null');
      return;
    }
    // 单计费上报
    AdReport.chargeMc({
      adType: adInfo?.adType || 0, // number 类型 广告类型，从后端取或者和pm确认
      chargeInfo: adChargeInfo,
      eventId //bid
    });
  }
};

export const reportChargeMv = (eventId: string, adInfo: any) => {
  if (adInfo?.hitAd === HIT_AD) {
    // 单计费上报
    const adChargeInfo = getAdChargeInfo(adInfo);
    reportRaptorMetrics({ adChargeInfoReport: adChargeInfo ? 1 : 0 }, {
      result: adChargeInfo ? 'success' : 'fail',
      type: 'mv',
      eventId
    });
    if (!adChargeInfo) {
      console.log('reportChargeMv, adChargeInfo is null');
      return;
    }
    AdReport.chargeMv({
      adType: adInfo?.adType || 0, // number 类型 广告类型，从后端取或者和pm确认
      chargeInfo: adChargeInfo,
      eventId, //bid
    });
  }
};

export const getAdChargeInfoForLx = (adInfo: any) => {
  const query: string = getAdChargeInfo(adInfo);
  if (query.length <= 0) {
    return {};
  }
  const queryObj = {};
  query.split('&').forEach((item) => {
    const index = item.indexOf('=');
    if (index > 0 && index < item.length) {
      const name = item.substring(0, index);
      const value = item.substring(index + 1, item.length);
      queryObj[name] = value;
    }
  });
  return queryObj;
};
